export default __webpack_public_path__ + "static/media/second-left-img@2x.e0b3ef9a.webp";